export const getters = {
    list: state => state.list,
    columns: state => state.columns,
    inventory: state => state.inventory,
    model: state => state.model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
};
